<template>
    <div>
        <!-- Onboarding Banner 1 -->
        <b-alert
            v-if="tab.onboarding_banner_1 === 0 && showNextBanner"
            show
            variant="info"
            dismissible
            @dismissed="dismissAndDelay('1')"
        >
            <p>
                <strong>Create Articles with AI</strong><br>
                Build your knowledge base quickly by generating articles using AI. Provide instant support to your users.
            </p>
            <b-button @click="generateArticleWithAI(); setOnboardingDone('1')" variant="primary">
                Generate Article with AI
            </b-button>
            <b-button @click="dismissAndDelay('1')" variant="link" class="text-muted">
                Skip <b-icon icon="arrow-right"></b-icon>
            </b-button>
        </b-alert>

        <!-- Onboarding Banner 2 -->
        <b-alert
            v-else-if="tab.onboarding_banner_2 === 0 && showNextBanner"
            show
            variant="warning"
            dismissible
            @dismissed="dismissAndDelay('2')"
        >
            <p>
                <strong>Organize with Topic Levels</strong><br>
                Structure your content with unlimited sublevels in topics. Make a comprehensive and easy-to-use knowledge base.
            </p>
            <b-button @click="addTopic(); setOnboardingDone('2')" variant="primary">Add Topic</b-button>
            <b-button @click="dismissAndDelay('2')" variant="link" class="text-muted">
                Skip <b-icon icon="arrow-right"></b-icon>
            </b-button>
        </b-alert>

        <!-- Onboarding Banner 3 -->
        <b-alert
            v-else-if="tab.onboarding_banner_3 === 0 && showNextBanner"
            show
            variant="success"
            dismissible
            @dismissed="dismissAndDelay('3')"
        >
            <p>
                <strong>Share Your Knowledge Base</strong><br>
                Make your help center easy to access. Embed it in your app or share the link so users can find answers anytime.
            </p>
            <b-button @click="getEmbedCode(); setOnboardingDone('3')" variant="primary">
                Get Embed Code
            </b-button>
            <b-button @click="copyKnowledgeBaseLink(); setOnboardingDone('3')" variant="primary">
                Copy Knowledge Base Link
            </b-button>
            <b-button @click="dismissAndDelay('3')" variant="link" class="text-muted">
                Skip <b-icon icon="arrow-right"></b-icon>
            </b-button>
        </b-alert>
    </div>
</template>

<script>
export default {
    props: {
        tab: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showNextBanner: true,
            nextBannerDelay: 5000,
        };
    },
    methods: {
        dismissAndDelay(key) {
            this.$set(this.tab, `onboarding_banner_${key}`, -1);
            this.$emit('onboarding-dismissed', `onboarding_banner_${key}`);
            this.showNextBanner = false;
            setTimeout(() => {
                this.showNextBanner = true;
            }, this.nextBannerDelay);
        },
        setOnboardingDone(key) {
            this.$set(this.tab, `onboarding_banner_${key}`, 1);
            this.$emit('onboarding-done', `onboarding_banner_${key}`);
            this.showNextBanner = false;
            setTimeout(() => {
                this.showNextBanner = true;
            }, this.nextBannerDelay);
        },
        generateArticleWithAI() {
            this.$emit('generate-article-with-ai');
        },
        addTopic() {
            this.$emit('add-topic');
        },
        getEmbedCode() {
            this.$emit('get-embed-code');
        },
        copyKnowledgeBaseLink() {
            this.$emit('copy-knowledge-base-link');
        },
    },
};
</script>
